import { DocumentDataType } from '@/types/doc';
import { Icon } from '@iconify/react';
import {
  Modal,
  ModalBody,
  ModalContent,
  Tooltip,
  useDisclosure,
} from '@nextui-org/react';
import { useState } from 'react';
import FileViewer from '../file-viewer/file-viewer';

interface DocumentViewerButtonProps {
  document: DocumentDataType;
  iconName?: string;
  className?: string;
  buttonClassName?: string;
  title?: string;
}

const DocumentViewerButton = ({
  document,
  iconName = 'mdi:file-document-search',
  className = 'text-gray-400 hover:text-primary text-xl',
  buttonClassName = 'hover:bg-gray-100 rounded-full transition-colors flex-shrink-0',
  title = 'View document',
}: DocumentViewerButtonProps) => {
  const [selectedDocument, setSelectedDocument] =
    useState<DocumentDataType | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleViewDocument = () => {
    setSelectedDocument(document);
    onOpen();
  };

  const handleCloseModal = () => {
    onClose();
    setSelectedDocument(null);
  };

  return (
    <>
      <Tooltip content={title}>
        <button
          onClick={handleViewDocument}
          className={buttonClassName}
          aria-label={title}
        >
          <Icon icon={iconName} className={className} />
        </button>
      </Tooltip>

      {/* Document Viewer Modal */}
      <Modal
        isOpen={isOpen}
        onClose={handleCloseModal}
        size="3xl"
        hideCloseButton
        classNames={{
          body: 'p-0',
        }}
      >
        <ModalContent>
          <ModalBody>
            {selectedDocument && (
              <FileViewer
                fileUrl={selectedDocument.latest_snapshot.file}
                height="90vh"
                onClose={handleCloseModal}
                filename={
                  selectedDocument.filename ||
                  selectedDocument.latest_snapshot.file_original_name
                }
                mimeType={selectedDocument.latest_snapshot.file_mimetype}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DocumentViewerButton;
